var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "q-display-1 q-mb-md" }, [
        _c("span", { staticClass: "q-headline text-weight-light" }, [
          _vm._v(_vm._s(_vm.$t("level_history")))
        ])
      ]),
      _c("q-table", {
        attrs: {
          data: _vm.history_level,
          columns: _vm.columns,
          "hide-bottom": "",
          "row-key": "__index"
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    {
                      key: "__index",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.__index) +
                          "\n            "
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      key: "user_full_name",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.user_full_name) +
                          "\n            "
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      key: "level_from",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.level_from) +
                          "\n            "
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      key: "level_to",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.level_to) +
                          "\n            "
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      key: "points_from",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.points_from) +
                          "\n            "
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      key: "points_to",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.points_to) +
                          "\n            "
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      key: "created_date",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.fDate(props.row.created_date)) +
                          "\n            "
                      )
                    ]
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _vm.showButtonsEdit
        ? _c("div", { staticClass: "row gutter-sm justify-end q-my-sm" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "positive",
                    label: _vm.$t("level_up"),
                    icon: "far fa-chevron-up",
                    disable: !_vm.allowed_to_level_up
                  },
                  on: {
                    click: function($event) {
                      return _vm.levelUp()
                    }
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c("q-table", {
        staticClass: "q-mt-md",
        attrs: {
          data: _vm.level_up_history,
          columns: _vm.columns_level_up_history,
          title: _vm.$t("level_up_history"),
          "row-key": "date_acquired",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [0],
          "binary-state-sort": "",
          "hide-bottom": ""
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c("q-td", { key: "level", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.level) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "date_acquired", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.fDateTime(props.row.date_acquired)) +
                          "\n            "
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    { key: "date_leveled_up", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.fDateTime(props.row.date_leveled_up)) +
                          "\n            "
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      key: "responsible_user_full_name",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.responsible_user_full_name) +
                          "\n            "
                      )
                    ]
                  )
                ],
                1
              )
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }